import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

function SubMenuComponent({ data }) {
  const regions = data.allStrapiRegions.nodes

  const france = regions
    .filter(e => e.slug.includes("france"))
    .sort(function (a, b) {
      if (a.region < b.region) {
        return -1
      }
      if (a.region > b.region) {
        return 1
      }
      return 0
    })

  const spotlight = regions.filter(
    e =>
      (!e.slug.includes("france") && !e.slug.includes("french")) ||
      e.slug === "french-wines"
  )
  //console.log(spotlight)
  return (
    <div
      className="absolute text-sm text-gray-500 w-full"
      style={{ top: "-5px" }}
    >
      {/* Presentational element used to render the bottom shadow, if we put the shadow on the actual panel it pokes out the top, so we use this shorter element to hide the top of the shadow */}

      <div className="relative bg-zinc-50	 h-[415px] shadow z-20">
        <div className="max-w-7xl h-full flex justify-center items-center mx-auto px-8">
          <div className="flex justify-between">
            {spotlight.map(item => (
              <div
                key={item.region}
                className="group p-12 relative text-base sm:text-sm"
              >
                <Link to={`/${item.slug}/`} className="hover:text-gray-800 p-0">
                  <div className="aspect-w-1 aspect-h-1 rounded-lg bg-gray-100 overflow-hidden group-hover:opacity-75">
                    <GatsbyImage
                      image={
                        item.Image.localFile.childImageSharp.gatsbyImageData
                      }
                      alt={`${item.region} + ' wine exports'`}
                      className="object-center object-cover shadow hover:shadow-lg"
                    />
                  </div>
                  <div className="flex">
                    <h2
                      aria-hidden="true"
                      className="mt-8 bg-red-700 text-white w-full shadow hover:shadow-lg  hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 rounded-lg px-5 py-2.5 text-center"
                      style={{ fontSize: "1rem" }}
                    >
                      {item.region} Wineries
                    </h2>
                  </div>
                </Link>
              </div>
            ))}
          </div>
          {/* <div className="row-start-1 gap-y-10 gap-x-8 text-sm">
              <h2 className="text-left ml-0 mb-8 px-[10px]">French Regions</h2>
              <div className="h-[50px] flex flex-wrap flex-start">
                {france.map(section => (
                  <ul
                    role="list"
                    aria-labelledby={`french-regions-wine-heading`}
                    className="h-auto"
                    key={section.slug}
                  >
                    <li className="flex width-auto">
                      <Link
                        to={`/${section.slug}/`}
                        className="hover:text-gray-800 p-0"
                      >
                        {section.region}
                      </Link>
                    </li>
                  </ul>
                ))}
              </div>
            </div> */}
        </div>
      </div>
    </div>
  )
}

export default function SubMenu(props) {
  return (
    <StaticQuery
      query={graphql`
        query dropDownNavigation {
          allStrapiRegions {
            nodes {
              region
              slug
              Image {
                localFile {
                  childImageSharp {
                    gatsbyImageData(width: 215, height: 215, quality: 60)
                  }
                }
              }
            }
          }
        }
      `}
      render={data => <SubMenuComponent data={data} />}
    />
  )
}
